import script from "./RoleRelationList.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleRelationList.vue?vue&type=script&setup=true&lang=ts"

import "./RoleRelationList.vue?vue&type=style&index=0&id=253bad50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-253bad50"]])

export default __exports__